// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__18ee3","col":"CardReaderDesc_col__1O6BQ","label":"CardReaderDesc_label__vqTnS"};